import { render, staticRenderFns } from "./term4.vue?vue&type=template&id=5ee527e8"
import script from "./term4.vue?vue&type=script&lang=js"
export * from "./term4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports